import { BestSellerHot, BestSellerPurchase } from '@zeelool/icon';

export default function BestsellerTagIcon({
  type,
  large = false,
  className,
}: {
  type: 'sales' | 'trend';
  large?: boolean;
  className?: string;
}) {
  const Icon = type === 'trend' ? BestSellerHot : BestSellerPurchase;

  return (
    <Icon
      className={`${
        large
          ? 'text-[14px] xl:text-[20px] 2xl:text-[28px]'
          : 'hidden text-[13px] min-[1880px]:block min-[1880px]:text-[28px]'
      } shrink-0 ${className || ''}`}
      aria-hidden
    />
  );
}
